import { render } from "./dan-alix-bag-product.vue?vue&type=template&id=a14729f8&scoped=true"
import script from "./dan-alix-bag-product.vue?vue&type=script&lang=js"
export * from "./dan-alix-bag-product.vue?vue&type=script&lang=js"

import "./dan-alix-bag-product.vue?vue&type=style&index=0&id=a14729f8&scoped=true&lang=css"
import "./dan-alix-bag-product.vue?vue&type=style&index=1&id=a14729f8&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a14729f8"]])

export default __exports__